//CREATE_SUPPORT_TICKET
export const CREATE_SUPPORT_TICKET_REQUEST = "CREATE_SUPPORT_TICKET_REQUEST";
export const CREATE_SUPPORT_TICKET_SUCCESS = "CREATE_SUPPORT_TICKET_SUCCESS";
export const CREATE_SUPPORT_TICKET_FAIL = "CREATE_SUPPORT_TICKET_FAIL";

//UPDATE_SUPPORT_TICKET
export const UPDATE_SUPPORT_TICKET_REQUEST = "UPDATE_SUPPORT_TICKET_REQUEST";
export const UPDATE_SUPPORT_TICKET_SUCCESS = "UPDATE_SUPPORT_TICKET_SUCCESS";
export const UPDATE_SUPPORT_TICKET_FAIL = "UPDATE_SUPPORT_TICKET_FAIL";

//GET_ALL_SUPPORT_TICKET
export const GET_ALL_SUPPORT_TICKET_REQUEST = "GET_ALL_SUPPORT_TICKET_REQUEST";
export const GET_ALL_SUPPORT_TICKET_SUCCESS = "GET_ALL_SUPPORT_TICKET_SUCCESS";
export const GET_ALL_SUPPORT_TICKET_FAIL = "GET_ALL_SUPPORT_TICKET_FAIL";

//GET_SUPPORT_TICKET_BY_ID
export const GET_SUPPORT_TICKET_BY_ID_REQUEST =
  "GET_SUPPORT_TICKET_BY_ID_REQUEST";
export const GET_SUPPORT_TICKET_BY_ID_SUCCESS =
  "GET_SUPPORT_TICKET_BY_ID_SUCCESS";
export const GET_SUPPORT_TICKET_BY_ID_FAIL = "GET_SUPPORT_TICKET_BY_ID_FAIL";

//CREATE_SUPPORT_MESSAGE
export const CREATE_SUPPORT_MESSAGE_REQUEST = "CREATE_SUPPORT_MESSAGE_REQUEST";
export const CREATE_SUPPORT_MESSAGE_SUCCESS = "CREATE_SUPPORT_MESSAGE_SUCCESS";
export const CREATE_SUPPORT_MESSAGE_FAIL = "CREATE_SUPPORT_MESSAGE_FAIL";

//GET_ALL_SUPPORT_MESSAGE_SUPPORT_TICKET_ID
export const GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_REQUEST =
  "GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_REQUEST";
export const GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_SUCCESS =
  "GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_SUCCESS";
export const GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_FAIL =
  "GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_FAIL";

export const GET_ALL_COMPANY_SUPPORT_TICKET_REQUEST =
  "GET_ALL_COMPANY_SUPPORT_TICKET_REQUEST";
export const GET_ALL_COMPANY_SUPPORT_TICKET_SUCCESS =
  "GET_ALL_COMPANY_SUPPORT_TICKET_SUCCESS";
export const GET_ALL_COMPANY_SUPPORT_TICKET_FAIL =
  "GET_ALL_Company_SUPPORT_TICKET_FAIL";

// ADMIN SUPPORT DETAIL ACTIONS (Separated from Support Widget)
export const ADMIN_GET_SUPPORT_TICKET_BY_ID_REQUEST = "ADMIN_GET_SUPPORT_TICKET_BY_ID_REQUEST";
export const ADMIN_GET_SUPPORT_TICKET_BY_ID_SUCCESS = "ADMIN_GET_SUPPORT_TICKET_BY_ID_SUCCESS";
export const ADMIN_GET_SUPPORT_TICKET_BY_ID_FAIL = "ADMIN_GET_SUPPORT_TICKET_BY_ID_FAIL";

export const ADMIN_GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_REQUEST = "ADMIN_GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_REQUEST";
export const ADMIN_GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_SUCCESS = "ADMIN_GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_SUCCESS";
export const ADMIN_GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_FAIL = "ADMIN_GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_FAIL";

export const ADMIN_CREATE_SUPPORT_MESSAGE_REQUEST = "ADMIN_CREATE_SUPPORT_MESSAGE_REQUEST";
export const ADMIN_CREATE_SUPPORT_MESSAGE_SUCCESS = "ADMIN_CREATE_SUPPORT_MESSAGE_SUCCESS";
export const ADMIN_CREATE_SUPPORT_MESSAGE_FAIL = "ADMIN_CREATE_SUPPORT_MESSAGE_FAIL";

export const ADMIN_UPDATE_SUPPORT_TICKET_REQUEST = "ADMIN_UPDATE_SUPPORT_TICKET_REQUEST";
export const ADMIN_UPDATE_SUPPORT_TICKET_SUCCESS = "ADMIN_UPDATE_SUPPORT_TICKET_SUCCESS";
export const ADMIN_UPDATE_SUPPORT_TICKET_FAIL = "ADMIN_UPDATE_SUPPORT_TICKET_FAIL";
